import ContentLayout from 'components/layouts/Default/ContentLayout'
import React from 'react'
import {NullAsDefault} from 'views/Shared'

const DefaultWrapper = ({
                            children,
                        }) => (
    <div className="flex w-full container mx-auto gap-3">
        {children}
    </div>
)

const DefaultTemplate = React.memo(
    ({
         children,
         Wrapper = DefaultWrapper,
         ...props
    }) => (
        <Wrapper>
            <ContentLayout
                style={{
                    padding: 0,
                }}
                renderHeader={NullAsDefault}
                renderRight={NullAsDefault}
                {...props}>
                {children}
            </ContentLayout>
        </Wrapper>
    )
)

export default DefaultTemplate
